export const MOBILE_NAV_BAR_ACTION_TYPES = {
  SET_MOBILE_NAV_IS_OPEN: 'SET_MOBILE_NAV_IS_OPEN',
  SET_MOBILE_SEARCHBAR_OPEN: 'SET_MOBILE_SEARCHBAR_OPEN',
};
